// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3e61n","disabled":"disabled-1wgPW","tertiary":"tertiary-YdVaH","secondary":"secondary-2CZ6z","primary":"primary-1Aaqs","alertIcon":"alertIcon-1_7FR"};